export const extraHealthTools = [
    {
        slug: "can-nang-bmi",
        type: "can_nang_bmi",
        name: "Cân nặng & BMI",
        short: "Cân nặng",
        description: "Ghi cân nặng, chiều cao và theo dõi BMI theo thời gian.",
        icon: "⚖",
        fields: [
            {
                key: "weight",
                label: "Cân nặng",
                unit: "kg",
                type: "number",
                min: 1
            },
            {
                key: "height",
                label: "Chiều cao",
                unit: "cm",
                type: "number",
                min: 1
            }
        ]
    },

    {
        slug: "nhiet-do",
        type: "nhiet_do",
        name: "Nhiệt độ cơ thể",
        short: "Nhiệt độ",
        description: "Ghi lại nhiệt độ cơ thể và thời điểm đo.",
        icon: "🌡",
        fields: [
            {
                key: "temperature",
                label: "Nhiệt độ",
                unit: "°C",
                type: "number",
                min: 20,
                max: 50
            },
            {
                key: "method",
                label: "Vị trí / phương pháp đo",
                type: "select",
                options: [
                    "Không ghi",
                    "Nách",
                    "Miệng",
                    "Tai",
                    "Trán",
                    "Trực tràng",
                    "Khác"
                ]
            }
        ]
    },

    {
        slug: "nhip-tho",
        type: "nhip_tho",
        name: "Nhịp thở",
        short: "Nhịp thở",
        description: "Ghi số nhịp thở đo được trong một phút.",
        icon: "〰",
        fields: [
            {
                key: "respiratoryRate",
                label: "Nhịp thở",
                unit: "lần/phút",
                type: "number",
                min: 1
            }
        ]
    },

    {
        slug: "vong-eo",
        type: "vong_eo",
        name: "Vòng eo",
        short: "Vòng eo",
        description: "Theo dõi số đo vòng eo theo thời gian.",
        icon: "◎",
        fields: [
            {
                key: "waist",
                label: "Vòng eo",
                unit: "cm",
                type: "number",
                min: 1
            }
        ]
    },

    {
        slug: "giac-ngu",
        type: "giac_ngu",
        name: "Giấc ngủ",
        short: "Giấc ngủ",
        description: "Ghi thời lượng và cảm nhận về giấc ngủ.",
        icon: "☾",
        fields: [
            {
                key: "sleepHours",
                label: "Thời gian ngủ",
                unit: "giờ",
                type: "number",
                min: 0,
                max: 24
            },
            {
                key: "quality",
                label: "Cảm nhận giấc ngủ",
                type: "select",
                options: [
                    "Rất tốt",
                    "Tốt",
                    "Bình thường",
                    "Kém",
                    "Rất kém"
                ]
            }
        ]
    },

    {
        slug: "luong-nuoc",
        type: "luong_nuoc",
        name: "Lượng nước",
        short: "Nước",
        description: "Ghi tổng lượng nước uống để theo dõi hằng ngày.",
        icon: "💧",
        fields: [
            {
                key: "water",
                label: "Lượng nước",
                unit: "mL",
                type: "number",
                min: 0
            }
        ]
    },

    {
        slug: "trieu-chung",
        type: "trieu_chung",
        name: "Triệu chứng hằng ngày",
        short: "Triệu chứng",
        description: "Ghi triệu chứng và mức độ cảm nhận để xem lại khi cần.",
        icon: "✚",
        fields: [
            {
                key: "symptom",
                label: "Triệu chứng",
                type: "text",
                placeholder: "Ví dụ: đau đầu, chóng mặt..."
            },
            {
                key: "severity",
                label: "Mức độ tự đánh giá",
                type: "select",
                options: [
                    "Nhẹ",
                    "Vừa",
                    "Nhiều"
                ]
            }
        ]
    },

    {
        slug: "van-dong",
        type: "van_dong",
        name: "Nhật ký vận động",
        short: "Vận động",
        description: "Ghi loại hoạt động và thời lượng vận động.",
        icon: "⚡",
        fields: [
            {
                key: "activity",
                label: "Hoạt động",
                type: "text",
                placeholder: "Ví dụ: đi bộ..."
            },
            {
                key: "duration",
                label: "Thời lượng",
                unit: "phút",
                type: "number",
                min: 0
            }
        ]
    },

    {
        slug: "buoc-chan",
        type: "buoc_chan",
        name: "Số bước chân",
        short: "Bước chân",
        description: "Ghi số bước chân từ điện thoại, đồng hồ hoặc thiết bị theo dõi.",
        icon: "♟",
        fields: [
            {
                key: "steps",
                label: "Số bước",
                unit: "bước",
                type: "number",
                min: 0
            }
        ]
    },

    {
        slug: "ghi-chu",
        type: "ghi_chu_suc_khoe",
        name: "Ghi chú sức khỏe",
        short: "Ghi chú",
        description: "Lưu các thông tin sức khỏe khác để tiện xem lại.",
        icon: "✎",
        fields: [
            {
                key: "content",
                label: "Nội dung",
                type: "textarea",
                placeholder: "Nhập ghi chú..."
            }
        ]
    }
];


export const findExtraHealthTool = (slug) =>
    extraHealthTools.find(
        (item) => item.slug === slug
    );


export const findExtraHealthToolByType = (type) =>
    extraHealthTools.find(
        (item) => item.type === type
    );
